import { useEffect } from 'react';
import { navigate } from 'wouter/use-browser-location';
import { Users } from '@platform/client';
import { AuthedPage, HeaderFooterLayout } from '../app';
import { HeroSection } from './home/HeroSection';
import { TestimonialsSection } from './home/TestimonialsSection';

const CorporateHomeContent = () => {
  const { data: user, isSuccess } = Users.useGetCurrentUser();
  const isCorporateAdmin = user?.accountType === 'corporate';

  useEffect(() => {
    if (isSuccess && !isCorporateAdmin) {
      navigate('/');
    }
  }, [isSuccess, isCorporateAdmin]);

  if (!user || !isCorporateAdmin) {
    return null;
  }

  return (
    <div className='-mt-12 bg-white pt-12'>
      <HeroSection
        corporateClientId={user.corporateClientId}
        corporateClientName={user.corporateClientName}
        corporateClientLogo={user.corporateClientLogo}
      />
      <TestimonialsSection corporateClientName={user.corporateClientName} />
    </div>
  );
};

export const CorporateHomePage = () => (
  <AuthedPage>
    <HeaderFooterLayout>
      <CorporateHomeContent />
    </HeaderFooterLayout>
  </AuthedPage>
);
